import React from 'react'
import { ReviewList } from './ReviewList'
import { useGoogleReviews } from '~/utils/googleReviews'

const ReviewsFullSection: React.FC = () => {
  const data = useGoogleReviews()

  if (!data || data.reviews.length === 0) return null

  return (
    <ReviewList
      summary={{ averageRating: data.averageRating }}
      reviews={data.reviews}
    />
  )
}

export default ReviewsFullSection
